import { render } from "./IconHtml.vue?vue&type=template&id=229fe7dc&scoped=true"
import script from "./IconHtml.vue?vue&type=script&lang=js"
export * from "./IconHtml.vue?vue&type=script&lang=js"

import "./IconHtml.vue?vue&type=style&index=0&id=229fe7dc&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229fe7dc"]])

export default __exports__